var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHourglassOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "#F5F6FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.0022 19.9506L35.5904 14.6817L38.9719 13.7756C39.145 13.7293 39.2486 13.5498 39.2022 13.3768L38.6122 11.1748C38.5659 11.0018 38.3864 10.8982 38.2134 10.9446L13.3629 17.6032C13.1899 17.6496 13.0863 17.8291 13.1326 18.0021L13.7226 20.204C13.769 20.377 13.9485 20.4806 14.1215 20.4343L17.503 19.5282L18.9148 24.7971C19.7735 28.0017 22.1961 30.3743 25.1425 31.3043C23.0558 33.5828 22.1441 36.8488 23.0028 40.0534L24.4146 45.3223L21.033 46.2284C20.86 46.2748 20.7564 46.4543 20.8027 46.6273L21.3927 48.8292C21.4391 49.0022 21.6186 49.1059 21.7916 49.0595L46.6421 42.4008C46.8151 42.3545 46.9187 42.175 46.8723 42.002L46.2823 39.8C46.236 39.627 46.0565 39.5234 45.8835 39.5698L42.5019 40.4759L41.0901 35.2069C40.2314 32.0023 37.8088 29.6298 34.8625 28.6998C36.9491 26.4212 37.8609 23.1552 37.0022 19.9506ZM38.2591 35.9655L39.6709 41.2344L27.2456 44.5638L25.8338 39.2948C25.3892 37.6355 25.6158 35.9017 26.4775 34.4149C27.3342 32.9253 28.7224 31.8622 30.3818 31.4176C32.0411 30.9729 33.7749 31.1995 35.2617 32.0612C36.7513 32.918 37.8144 34.3062 38.2591 35.9655ZM34.1711 20.7092C34.6158 22.3685 34.3892 24.1023 33.5275 25.5891C32.6707 27.0788 31.2825 28.1419 29.6232 28.5865C27.9639 29.0311 26.2301 28.8045 24.7433 27.9428C24.0099 27.5231 23.3672 26.9618 22.8527 26.2916C22.3381 25.6213 21.9619 24.8555 21.7459 24.0385L20.3341 18.7696L32.7593 15.4403L34.1711 20.7092Z",
    fill: "url(#paint0_linear_3117_8049)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3117_8049",
    x1: 21.477,
    y1: 49.1438,
    x2: 42.8536,
    y2: 13.4509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD50FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglassOutlined);
export default __webpack_public_path__ + "static/media/hourglassOutlined.f2ecd06bfb825e806b0119792f2ec342.svg";
export { ForwardRef as ReactComponent };